import { useContext } from "react";
import useSWR from "swr";
import { InvoiceDetailsModel, InvoiceTotalInfoModel } from "../models/ChasableModels";
import { ContactModel } from "../models/ContactModels";
import { PaymentDetailsModel } from "../models/PaymentModels";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";
import { CustomerModel } from "../models/CustomerModels";

export const useCustomer = (customerId: string | null | undefined) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<CustomerModel>(
    customerId ? `${environment.apiUrl}/api/contacts/customers/${customerId}` : null,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("The customer details failed to load, please try again later", "error");
      },
    }
  );

  return {
    customer: data,
    isLoading,
    isError: !!error,
  };
};
